<template>
  <el-dialog
    :title="$t('deleteMerchant.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center;">
      <p>{{ $t('deleteMerchant.confirmDeleteMerchant') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('deleteMerchant.cancel') }}
      </el-button>
      <el-button type="primary" @click="deleteMerchant">
        {{ $t('deleteMerchant.confirmDelete') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteStore } from '@/api/admin/deleteMerchant/deleteMerchantApi'

export default {
  name: 'DeleteMerchant',
  data() {
    return {
      dialogVisible: false,
      deleteMerchantInfo: {
        storeId: '',
        storeTypeCd: ''
      }
    }
  },
  methods: {
    open(params) {
      this.deleteMerchantInfo = { ...params }
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteMerchantInfo = {
        storeId: '',
        storeTypeCd: ''
      }
    },
    async deleteMerchant() {
      try {
        const {code,msg} = await deleteStore(this.deleteMerchantInfo)
        if(code != 0){
          this.$message.error(msg)
          return
        }
        this.$message.success(msg)
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
        this.$message.error(error.message)
      }
    }
  }
}
</script>